import React, {Component} from 'react';
import './App.css';
import './css/all.css';
import './css/modalOrder.css';
import './css/searchPanel.css';
import  './css/searchPanelResults.css'; 
import './css/hotelsList.css';
import './css/checkbox.css';



//import './css/fontawesome.min.css';
//import 'bootstrap/dist/css/bootstrap.min.css';


import AppContainer from './hoc/AppContainer.hoc'


/**************************/


class App extends Component {

  render() { 
  
    return (      
      <React.Fragment>
        <AppContainer />
      </React.Fragment>
    )
  }
}


  export default App;

